import { render, staticRenderFns } from "./legalRegister.vue?vue&type=template&id=1a6f5281&scoped=true"
import script from "./legalRegister.vue?vue&type=script&lang=js"
export * from "./legalRegister.vue?vue&type=script&lang=js"
import style0 from "./legalRegister.vue?vue&type=style&index=0&id=1a6f5281&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../usr/local/node_16.9.1/lib/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6f5281",
  null
  
)

export default component.exports